import { TermsAndPrivacyOverlayData } from 'src/store/overlay'

import { BackButton, MainButton } from '@ds'
import { Privacy, Terms } from '@shared'
import { useOverlayActions } from '@store'

import styles from './TermsAndPrivacy.module.scss'

export const TermsAndPrivacy = ({
  type,
}: TermsAndPrivacyOverlayData['payload']) => {
  const { hideOverlay } = useOverlayActions()

  const handleClose = () => {
    hideOverlay()
  }

  return (
    <div className={styles.container}>
      <BackButton onClick={handleClose} />
      <MainButton hidden />
      {type === 'terms' ? <Terms /> : <Privacy />}
    </div>
  )
}
